import Phaser from "phaser";
import LoadingScene from "@/games/KombatTutorial-2/scenes/LoadingScene";
import LandingScene from "@/games/KombatTutorial-2/scenes/LandingScene";
import QuestionScene from "@/games/KombatTutorial-2/scenes/QuestionScene";
import PlayScene from "@/games/KombatTutorial-2/scenes/PlayScene";
import Settings from "@/games/KombatTutorial-2/scenes/Settings";

function launch(containerId) {
  return new Phaser.Game({
    type: Phaser.AUTO,
    backgroundColor: 0xf5f5f5,
    parent: containerId,
    scale: {
      parent: containerId,
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: 480,
      height: 854,
    },
    physics: {
      default: "arcade",
    },
    dom: {
      createContainer: true,
    },
    scene: [LoadingScene, LandingScene, QuestionScene, PlayScene, Settings],
  });
}

export default launch;
export { launch };
